module.exports = __webpack_public_path__ + "img/luke_skywalker_character_profile.ecd8580e.jpg";